import React from "react"
import { useOutlet } from "react-router-dom"

export const Info = () => {
  const outlet = useOutlet()
  return <>{outlet}</>
}
